import React, { useCallback } from 'react';

import { Filter2, IFilterAvailableProps } from '../../../new_filter/Filter2';
import { NumberInputRange } from '../../../common/NewNumberInputRange/NumberInputRange';
import { LandAreaFilter } from '../../../../models/Filter';
import { INumberRange } from '../../../../types/IRange';

interface IDesktopLandAreaFilterProps extends IFilterAvailableProps {
    filter: LandAreaFilter;
    handleChange: (value: LandAreaFilter) => void;
}

export const DesktopLandAreaFilterView: React.FC<IDesktopLandAreaFilterProps> = ({
    filter,
    handleChange,
    withoutTitle
}) => {
    const handleAreaChange = useCallback((value: INumberRange) => {
        handleChange(new LandAreaFilter(value));
    }, [ handleChange ]);

    return (
        <Filter2 filterTitle={withoutTitle ? undefined : 'Площадь участка'}>
            <NumberInputRange
                size='s'
                unit='сот.'
                fromPostfix='сот.'
                value={filter.value}
                onChange={handleAreaChange}
                max={1_000_000}
            />
        </Filter2>
    );
};
